var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 14.0344L8.1 14.9789V8.755C8.09901 8.50723 8.00527 8.2698 7.839 8.09389L2.007 1.88889H16.011L10.188 8.09389C10.0217 8.2698 9.92799 8.50723 9.927 8.755L9.9 16.0556L11.7 17V9.14222L17.622 2.83333C17.8589 2.58113 17.9942 2.24296 18 1.88889V0.944444C18 0.693962 17.9052 0.453739 17.7364 0.276622C17.5676 0.0995039 17.3387 0 17.1 0H0.9C0.661305 0 0.432387 0.0995039 0.263604 0.276622C0.0948213 0.453739 0 0.693962 0 0.944444V1.88889C0.00575775 2.24296 0.141107 2.58113 0.378 2.83333L6.3 9.14222V14.0344Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7849919db58b7c50194911b3867cb806.svg";
export { ForwardRef as ReactComponent };